import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { showNotification } from "../../common/headerSlice"
import api from "../../../utils/axios"
import { triggerRefresh } from "../../../utils/refreshRegistry";

async function deleteTheSpecialMeeting(specialMeetingId) {
  try {
    const deleteSpecialMeeting = await api.delete(`/api/special-meetings/${specialMeetingId}`, {
      withCredentials: true,
    });
    return deleteSpecialMeeting
  } catch (error) {
    console.error("Error deleting special meeting:", error);
    throw error;
  }
}

function DeleteSpecialMeetingModalBody({closeModal, extraObject}){
  const dispatch = useDispatch()
  const specialMeetingId = extraObject;
  const [specialMeeting, setSpecialMeeting] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(false);

  // Fetch message details on mount
  useEffect(() => {
    const fetchSpecialMeeting = async () => {
      try {
        const response = await api.get(`/api/special-meetings/${specialMeetingId}`);
        setSpecialMeeting(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching special meeting:", error);
        dispatch(showNotification({ 
          message: "Failed to load special meeting details.", 
          status: 0 
        }));
        setLoading(false);
      }
    };
    
    fetchSpecialMeeting();
  }, [specialMeetingId, dispatch]);

  const deleteSpecialMeeting = async () => {
    setDeleting(true);
    try {
      const response = await deleteTheSpecialMeeting(specialMeetingId);
      console.log(response.data);
      const message = "Message deleted successfully!";
      dispatch(showNotification({ message, status: 1 }));
      closeModal()
      triggerRefresh("specialMeetings");
    } catch (error) {
      console.error("Error deleting special meeting:", error);
      const errorMessage = error.response?.data?.message || "Failed to delete special meeting. Please try again.";
      dispatch(showNotification({ 
        message: errorMessage, 
        status: 0 
      }));
    } finally {
      setDeleting(false);
    }
  }

  if (loading) {
    return (
      <>
        <div className="flex justify-center items-center py-8">
          <span className="loading loading-spinner loading-lg"></span>
        </div>
      </>
    );
  }

  return (
    <>
      {specialMeeting && (
        <div className="mt-4 text-sm text-gray-600">
          <p><strong>Id:</strong> {specialMeeting.id}</p>
          <p><strong>Name:</strong> {specialMeeting.name}</p>
        </div>
      )}

      <div className="modal-action">
        <button 
          className="btn btn-ghost" 
          onClick={() => closeModal()}
          disabled={deleting}
        >
          Cancel
        </button>
        
        <button 
          className="btn btn-error px-6" 
          onClick={() => deleteSpecialMeeting()}
          disabled={deleting}
        >
          {deleting ? (
            <>
              <span className="loading loading-spinner loading-sm"></span>
              Deleting...
            </>
           ) : (
            "Delete"
          )}
        </button>
      </div>
    </>
  )
}

export default DeleteSpecialMeetingModalBody

